import alt from 'alt'
import { createStore } from 'alt-utils/lib/decorators'
import Immutable from 'immutable'
import { CheckDetailActions } from 'actions'
import { UserStore } from 'stores'

@createStore(alt)
export default class CheckDetailStore {
  constructor() {
    this.state = {
      result: Immutable.Map({}),
      adhocUrl: null,
      fetched: false
    }

    this.bindActions(CheckDetailActions)
  }

  static displayName = 'CheckDetailStore'

  fetching(adhocUrl) {
    this.setState({ result: Immutable.Map({}), adhocUrl: adhocUrl, fetched: false })
  }

  fetched(result) {
    result = Immutable.fromJS(result)
    this.setState({ result, fetched: true })
  }
}



// WEBPACK FOOTER //
// ./app/stores/CheckDetailStore.js